<template>
  <div class="logout">
    Sie sind jetzt abgemeldet.
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Logout',
  components: {},
  async mounted () {
    await this.LogOut()
    this.$bubble('logout')
    this.$router.push('/login')
  },
  data () {
    return {
    }
  },
  methods: {
    ...mapActions(['LogOut'])
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/vue/components/Logout.vue